let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("718G0")).then(() => parcelRequire('iZY6P'));